import Populator from './populator.js';

export default class MyAccount2Populator extends Populator {
    constructor(input) {
        super(input);
        this.input = input;
        this.param = input.el.dataset.myAccount2;
        this.bind();
    }

    bind() {
        HONDA.MyAccount2.addEventListener('login', () => this.populate());
    }

    async populate() { 
        if(HONDA?.MyAccount2?.isLoggedIn()) {
            const data = await HONDA.MyAccount2.client.getPersonalDetails();
            if(data) {
                const value = this.get(this.param, data);
                if(value) {
                    super.populate(value); 
                }
            }
        }
    }

    get(path, data) {
        return new String(path.split('.').reduce((p, c) => p && p[c] || '', data)).replace(/"/g, '');
    }

    static applies(input) {
        return HONDA.MyAccount2 && input.el.dataset.myAccount2 != undefined;
    }
}
